import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  DashboardRowSchema,
  DetailResponseSchema,
  FinRecResponseSchema,
  MetricTimeSeriesRowSchema,
  OverviewResponseSchema,
} from '../shared/schemas/DashboardSchema.js';

export type DashboardRowType = z.infer<typeof DashboardRowSchema>;
export type OverviewResponseType = z.infer<typeof OverviewResponseSchema>;
export type DetailResponseType = z.infer<typeof DetailResponseSchema>;
export type FinRecResponseType = z.infer<typeof FinRecResponseSchema>;
export type MetricTimeSeriesRowType = z.infer<typeof MetricTimeSeriesRowSchema>;

// Dashboard payloads carry dynamic dataframe rows with verbatim column keys, so
// every endpoint disables camelCasing (`response.camelCaseBody: false`) to keep
// those keys intact for the consuming components.

// We will refactor snake case params when we understand how should work feature
// Current state of dashboard feature - code fully generated by Alessandro via AI
const rawResponse = { response: { camelCaseBody: false } } as const;

export const getOverview = defaultClient.query({
  url: 'ai-assistant/dashboards/overview' as const,
  method: 'GET',
  clientOptions: rawResponse,
  responseSchema: OverviewResponseSchema,
});

export const getDetail = defaultClient.query({
  url: 'ai-assistant/dashboards/detail' as const,
  method: 'GET',
  clientOptions: rawResponse,
  responseSchema: DetailResponseSchema,
});

export const getFinRec = defaultClient.query({
  url: 'ai-assistant/dashboards/finrec' as const,
  method: 'GET',
  clientOptions: rawResponse,
  responseSchema: FinRecResponseSchema,
});

export const getMetricTimeseries = defaultClient.query({
  url: 'ai-assistant/dashboards/metric-timeseries' as const,
  method: 'GET',
  clientOptions: rawResponse,
  querySchema: z.object({
    campaignId: z.string(),
    mediaplanId: z.string(),
  }),
  snakeCaseQueryParams: true,
  responseSchema: z.array(MetricTimeSeriesRowSchema),
});
